import React from "react";
import styles from "./styles.module.scss";
import PrimaryButton from "../../commons/components/PrimaryButton/PrimaryButton";
import CustomInput from "../../commons/components/CustomInput/CustomInput";
import CustomPagination from "../../commons/components/CustomPagination";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../commons/components/CustomTable";
import GradientText from "../../commons/components/GradientText/GradientText";

interface Props {
  selectedProductId: number;
  setKeyword: React.Dispatch<React.SetStateAction<string>>;
  page: number;
  total: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  onShowSizeChange: (current: number, page: number) => void;
  perPage: number;
  dataSrc: any[];
  columns: any[];
  loading: boolean;
  isEdit: boolean;
}

const GroupMenuLayout: React.FC<Props> = ({
  columns,
  dataSrc,
  loading,
  onShowSizeChange,
  page,
  perPage,
  selectedProductId,
  setKeyword,
  setPage,
  total,
  isEdit,
}) => {
  const navigate = useNavigate();
  return (
    <div>
      {" "}
      <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>{isEdit ? "Edit Group" : "Group Management"}</div>
          <div className={styles.btnBoxMenu}>
            <div className={styles.btnCancel} onClick={() => navigate(-1)}>
              <GradientText text={"Back"}></GradientText>
            </div>
            <PrimaryButton className={styles.cloneProductBtn} type="submit">
              {` ${isEdit ? "Edit" : "Create "}`} Group Name
            </PrimaryButton>
          </div>
        </div>
      </div>
      <div className={styles.input}>
        <CustomInput
          name="group-name"
          title="Group Name"
          label="Group Name"
          placeholder="Enter group name"
          rules={[
            {
              required: true,
              message: "Name is required",
            },
          ]}
        />
      </div>
      <div className={styles.searchBox}>
        <CustomInput
          className={styles.inputSearch}
          type="search"
          placeholder="Search for product name, ID"
          onChange={e => {
            setKeyword(e.target.value);
          }}
        />
        <span>Product Quantity: {selectedProductId}</span>
      </div>
      <div className={styles.paginationWrapper}>
        <CustomPagination
          defaultCurrent={1}
          showSizeChanger
          current={page}
          onChange={page => setPage(page)}
          total={total}
          onShowSizeChange={onShowSizeChange}
          pageSize={perPage}
        />
      </div>
      <CustomTable pagination={false} columns={columns} dataSource={dataSrc} scroll={{ x: 400 }} loading={loading} />
    </div>
  );
};

export default GroupMenuLayout;
